import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {DialogModel} from '@shared/models/dialog.model';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    standalone: false,
    selector: 'particle-end-demo',
  templateUrl: './end-demo.component.html',
  styleUrls: ['./end-demo.component.scss']
})
export class EndDemoComponent implements OnInit, OnDestroy, IDialogView {
  formGroup: FormGroup;
  data: DialogModel;
  private ngUnsubscribe = new Subject<void>();

  constructor(private formBuilder: FormBuilder) {

  }

  /**
   * False for a Show Space or Playground. The mandatory comment captures demo feedback; a presenter
   * closing their own rehearsal has no reader for it, and blocking the exit until they type
   * something is friction with no payoff. Defaults to true so existing callers are unaffected.
   */
  get commentRequired(): boolean {
    return this.data?.input?.['commentRequired'] !== false;
  }

  /**
   * True when a Show Playground is being left with staged edits. Shown here rather than as a second
   * prompt in front of this dialog — this IS the confirm step.
   */
  get warnUnsaved(): boolean {
    return this.data?.input?.['warnUnsaved'] === true;
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      comment : ['', this.commentRequired ? [Validators.required] : []]
    });
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  onOkClicked() {
    this.data.input['comment'] = this.formGroup.controls['comment'].value;
    return true;
  }
}
